/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FnbService {
    /**
     * fnb.catalog.masterdata
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static masterdataFnb(
        organizer: string,
        requestBody: any,
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/masterdata/fnb',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.material.create
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static materials(
        organizer: string,
        requestBody: {
            base_uom?: string;
            catch_weight?: boolean;
            code?: string;
            is_sellable?: boolean;
            name?: string;
            std_cost?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/materials',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.barcode.set
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static materialsBarcode(
        organizer: string,
        requestBody: {
            barcode?: string;
            material_id?: number;
            uom_code?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/materials/barcode',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.barcode.resolve
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static materialsBarcodeResolve(
        organizer: string,
        requestBody: {
            barcode?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/materials/barcode/resolve',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.material.uom.set
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static materialsUom(
        organizer: string,
        requestBody: {
            factor_to_base?: number;
            material_id?: number;
            uom_code?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/materials/uom',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.material.uom.list
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static materialsUomList(
        organizer: string,
        requestBody: {
            material_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/materials/uom/list',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.material.yield.set
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static materialsYield(
        organizer: string,
        requestBody: {
            material_id?: number;
            yield?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/materials/yield',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.category.create
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static menuCategories(
        organizer: string,
        requestBody: {
            name?: string;
            outlet_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/menu/categories',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.item.create
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static menuItems(
        organizer: string,
        requestBody: {
            category_id?: number | null;
            channels?: Array<string>;
            code?: string;
            is_combo?: boolean;
            name?: string;
            outlet_id?: number;
            price_minor?: number;
            tax_group?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/menu/items',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.category.list — hand-added (GĐ2), gateway route đã có sẵn (services/gateway/internal/server/api.go:72)
     * nhưng client generated-fnbpos trước đó chưa từng bind endpoint này (không dùng ở đâu tới GĐ2).
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static menuCategoriesList(
        organizer: string,
        requestBody: {
            outlet_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/menu/categories/list',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.item.list
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static menuItemsList(
        organizer: string,
        requestBody: {
            outlet_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/menu/items/list',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.modifier_group.set
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static menuModifierGroups(
        organizer: string,
        requestBody: {
            code?: string;
            max_select?: number;
            menu_item_id?: number;
            min_select?: number;
            name?: string;
            required?: boolean;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/menu/modifier-groups',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.modifier.set
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static menuModifiers(
        organizer: string,
        requestBody: {
            code?: string;
            group_code?: string;
            material_id?: number | null;
            material_qty?: number;
            menu_item_id?: number;
            name?: string;
            price_minor?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/menu/modifiers',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.retail_item.create
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static menuRetailItems(
        organizer: string,
        requestBody: {
            channels?: Array<string>;
            code?: string;
            material_id?: number;
            name?: string;
            outlet_id?: number;
            price_minor?: number;
            qty_per_unit?: number;
            tax_group?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/menu/retail-items',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.variation.set
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static menuVariations(
        organizer: string,
        requestBody: {
            code?: string;
            menu_item_id?: number;
            name?: string;
            price_delta_minor?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/menu/variations',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.outlet.create
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static outlets(
        organizer: string,
        requestBody: {
            code?: string;
            group_id?: string;
            name?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/outlets',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.outlet.list
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static outletsList(
        organizer: string,
        requestBody: {
            group_id?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/outlets/list',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.po.create
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static purchaseOrders(
        organizer: string,
        requestBody: {
            lines?: Array<{
                material_id?: number;
                price_minor?: number;
                qty?: number;
                uom_code?: string;
            }>;
            note?: string;
            supplier_id?: number;
            warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/purchase-orders',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.po.get
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static purchaseOrdersGet(
        organizer: string,
        requestBody: {
            po_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/purchase-orders/get',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.grn.create
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static purchaseOrdersGrn(
        organizer: string,
        requestBody: {
            lines?: Array<{
                expiry?: string | null;
                line_no?: number;
                lot_code?: string;
                qty_received?: number;
            }>;
            note?: string;
            po_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/purchase-orders/grn',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.invoice.add
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static purchaseOrdersInvoice(
        organizer: string,
        requestBody: {
            invoice_date?: string;
            invoice_no?: string;
            lines?: Array<{
                line_no?: number;
                price_minor?: number;
                qty?: number;
            }>;
            note?: string;
            po_id?: number;
            supplier_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/purchase-orders/invoice',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.landed_cost.apply
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static purchaseOrdersLandedCost(
        organizer: string,
        requestBody: {
            amount_minor?: number;
            description?: string;
            grn_id?: number;
            method?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/purchase-orders/landed-cost',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.po.match
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static purchaseOrdersMatch(
        organizer: string,
        requestBody: {
            po_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/purchase-orders/match',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.recipe.set
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static recipes(
        organizer: string,
        requestBody: {
            material_id?: number;
            menu_item_id?: number;
            qty_per_unit?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/recipes',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.recipe.version.set
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static recipesVersion(
        organizer: string,
        requestBody: {
            effective_from?: string;
            effective_to?: string;
            material_id?: number;
            menu_item_id?: number;
            outlet_id?: number | null;
            qty_per_unit?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/recipes/version',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.stock.cogs
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static reportsCogs(
        organizer: string,
        requestBody: {
            order_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/reports/cogs',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.stock.inventory
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static reportsInventory(
        organizer: string,
        requestBody: {
            expiring_before?: string | null;
            material_id?: number;
            warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/reports/inventory',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.stock.inv_summary
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static reportsInventorySummary(
        organizer: string,
        requestBody: {
            expiring_days?: number;
            tag?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/reports/inventory-summary',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.stock.profit
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static reportsProfit(
        organizer: string,
        requestBody: {
            from?: string;
            outlet_id?: number;
            to?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/reports/profit',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.stock.reorder_by_tag
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static reportsReorderByTag(
        organizer: string,
        requestBody: {
            tag?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/reports/reorder-by-tag',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.stock.variance
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static reportsVariance(
        organizer: string,
        requestBody: {
            from?: string;
            to?: string;
            warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/reports/variance',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.stock.wastage
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static reportsWastage(
        organizer: string,
        requestBody: {
            from?: string;
            to?: string;
            warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/reports/wastage',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.seed
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static seedFnb(
        organizer: string,
        requestBody: any,
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/seed/fnb',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.stock.adjust
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockAdjust(
        organizer: string,
        requestBody: {
            delta?: number;
            lot_id?: number;
            note?: string;
            reason?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/adjust',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.lot.receive
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockLots(
        organizer: string,
        requestBody: {
            expiry?: string | null;
            lot_code?: string;
            material_id?: number;
            qty?: number;
            unit_cost?: number;
            uom?: string;
            warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/lots',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.par.set
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockPar(
        organizer: string,
        requestBody: {
            material_id?: number;
            par_level?: number;
            reorder_point?: number;
            warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/par',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.receive.non_po
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockReceiveNonPo(
        organizer: string,
        requestBody: {
            expiry?: string | null;
            lot_code?: string;
            material_id?: number;
            qty?: number;
            supplier_id?: number;
            unit_cost?: number;
            uom?: string;
            warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/receive-non-po',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.stock.reorder
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockReorder(
        organizer: string,
        requestBody: {
            warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/reorder',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.stock.set
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockSet(
        organizer: string,
        requestBody: {
            material_id?: number;
            on_hand?: number;
            uom?: string;
            warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/set',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.stock.stocktake
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockStocktake(
        organizer: string,
        requestBody: {
            counted_qty?: number;
            lot_id?: number;
            note?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/stocktake',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.stocktake_session.open
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockStocktakes(
        organizer: string,
        requestBody: {
            blind?: boolean;
            note?: string;
            warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/stocktakes',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.stocktake_session.cancel
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockStocktakesCancel(
        organizer: string,
        requestBody: {
            session_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/stocktakes/cancel',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.stocktake_session.count
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockStocktakesCount(
        organizer: string,
        requestBody: {
            counted_qty?: number;
            material_id?: number;
            session_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/stocktakes/count',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.stocktake_session.get
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockStocktakesGet(
        organizer: string,
        requestBody: {
            session_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/stocktakes/get',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.stocktake_session.post
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockStocktakesPost(
        organizer: string,
        requestBody: {
            session_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/stocktakes/post',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.stock.transfer
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockTransfer(
        organizer: string,
        requestBody: {
            dst_warehouse_id?: number;
            material_id?: number;
            qty?: number;
            src_warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/transfer',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.transfer_order.create
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockTransfers(
        organizer: string,
        requestBody: {
            dst_warehouse_id?: number;
            lines?: Array<{
                material_id?: number;
                qty?: number;
            }>;
            note?: string;
            src_warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/transfers',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.transfer_order.cancel
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockTransfersCancel(
        organizer: string,
        requestBody: {
            received?: Record<string, any>;
            transfer_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/transfers/cancel',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.transfer_order.dispatch
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockTransfersDispatch(
        organizer: string,
        requestBody: {
            received?: Record<string, any>;
            transfer_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/transfers/dispatch',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.transfer_order.get
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockTransfersGet(
        organizer: string,
        requestBody: {
            received?: Record<string, any>;
            transfer_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/transfers/get',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.transfer_order.receive
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static stockTransfersReceive(
        organizer: string,
        requestBody: {
            received?: Record<string, any>;
            transfer_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/stock/transfers/receive',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.sub_recipe.set
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static subRecipes(
        organizer: string,
        requestBody: {
            component_material_id?: number;
            parent_material_id?: number;
            qty_per_unit?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/sub-recipes',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.supplier.create
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static suppliers(
        organizer: string,
        requestBody: {
            address?: string;
            code?: string;
            email?: string;
            name?: string;
            phone?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/suppliers',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.ap.balance
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static suppliersApBalance(
        organizer: string,
        requestBody: {
            supplier_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/suppliers/ap/balance',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.ap.payment
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static suppliersApPayment(
        organizer: string,
        requestBody: {
            amount_minor?: number;
            note?: string;
            ref?: string;
            supplier_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/suppliers/ap/payment',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.supplier.list
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static suppliersList(
        organizer: string,
        requestBody: any,
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/suppliers/list',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.supplier.price.set
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static suppliersPrices(
        organizer: string,
        requestBody: {
            lead_time_days?: number;
            material_id?: number;
            moq?: number;
            price_minor?: number;
            supplier_id?: number;
            uom_code?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/suppliers/prices',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.supplier.price.history
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static suppliersPricesHistory(
        organizer: string,
        requestBody: {
            material_id?: number;
            supplier_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/suppliers/prices/history',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.supplier.price.list
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static suppliersPricesList(
        organizer: string,
        requestBody: {
            material_id?: number;
            supplier_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/suppliers/prices/list',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.supplier.rating.add
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static suppliersRatings(
        organizer: string,
        requestBody: {
            note?: string;
            on_time?: boolean;
            quality_score?: number;
            supplier_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/suppliers/ratings',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.supplier.return
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static suppliersReturns(
        organizer: string,
        requestBody: {
            material_id?: number;
            qty?: number;
            reason?: string;
            supplier_id?: number;
            uom?: string;
            warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/suppliers/returns',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.catalog.supplier.scorecard
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static suppliersScorecard(
        organizer: string,
        requestBody: {
            supplier_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/suppliers/scorecard',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.warehouse.create
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static warehouses(
        organizer: string,
        requestBody: {
            category?: string;
            name?: string;
            outlet_id?: number | null;
            tags?: Array<string>;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/warehouses',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.warehouse.list
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static warehousesList(
        organizer: string,
        requestBody: {
            tag?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/warehouses/list',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.warehouse.list_by_tag
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static warehousesListByTag(
        organizer: string,
        requestBody: {
            tag?: string;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/warehouses/list-by-tag',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.warehouse.map
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static warehousesMap(
        organizer: string,
        requestBody: {
            outlet_id?: number;
            priority?: number;
            warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/warehouses/map',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.warehouse.mappings
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static warehousesMappings(
        organizer: string,
        requestBody: {
            outlet_id?: number;
            priority?: number;
            warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/warehouses/mappings',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * fnb.warehouse.unmap
     * @param organizer Organizer slug (Riptik) — dùng làm tenant_id F&B (ánh xạ 1:1)
     * @param requestBody
     * @returns any OK (envelope success/data hoặc error)
     * @throws ApiError
     */
    public static warehousesUnmap(
        organizer: string,
        requestBody: {
            outlet_id?: number;
            priority?: number;
            warehouse_id?: number;
        },
    ): CancelablePromise<{
        data?: Record<string, any>;
        error?: string;
        message?: string;
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/organizers/{organizer}/fnbpos/warehouses/unmap',
            path: {
                'organizer': organizer,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
